import {
    postFilesLoading,
    postFilesRequest,
    postFilesSuccess,
    postFilesReject,
    postFilesReset
} from "../../actions/filesRoute/post";

export const postFiles = (formData) => async (dispatch, getState) => {
    dispatch(postFilesLoading());
    try {
        const { data } = await postFilesRequest(formData, getState);
        dispatch(postFilesSuccess(data))
    } catch (error) {
        dispatch(postFilesReject(error))
    } finally {
        setTimeout(() => { dispatch(postFilesReset()) }, 3000);
    }
    return Promise.resolve();
};